import { extendTheme } from "@chakra-ui/react";

/**
 * Chakra UI theme: color palettes (`principal`, `secondary`), typography and
 * component style overrides shared across the app.
 */
const Theme = extendTheme({
    config: {
        initialColorMode: "light",
        useSystemColorMode: true,
    },
    fonts: {
        body: "Poppins, sans-serif",
        heading: "Poppins, sans-serif",
    },
    colors: {
        principal: {
            blue: '#011936',
            green: '#3DDD97',
            grey: '#515B67',
            white: '#FFFFFF',
        },
        // Full YTG palette (indigo, centered on brand.ytg.main #41368D at 500) so
        // `colorScheme="ytg"` works on Chakra components (Stepper, Button, Radio…).
        ytg: {
            50: '#EDEBF6',
            100: '#D3CDE9',
            200: '#B4AAD8',
            300: '#9184C4',
            400: '#6C5CB0',
            500: '#41368D',
            600: '#3A3079',
            700: '#2E2661',
            800: '#221C48',
            900: '#16122F',
        },
        secondary: {
            orange: '#FC6C39',
            yellow: '#FABA52',
            purple: '#BB6FCC',
            green: '#58BD77',
            blue: '#3F96FF',
            red: '#FA617B',
        },
        brand: {
            ytg: {
                main: '#41368D',
                soseo: '#1BB395',
                dseo: '#F8AC59',
            },
            // Admin section identity: a deep ruby that echoes the red "Admin"
            // navbar button (secondary.red), dark enough for white text. Used by
            // the shared PageHeader `variant="admin"` so every admin page shares
            // one look without duplicating styles.
            admin: {
                main: '#8B2D4C',
                accent: '#FA617B',
            },
        },
    },
    // Reusable named style for the admin page banner — apply with
    // `layerStyle="adminBanner"` anywhere an admin-themed surface is needed.
    layerStyles: {
        adminBanner: {
            bg: 'brand.admin.main',
            color: 'white',
        },
    },
    gradients: {
        gradient1: 'linear-gradient(135deg, #FC6C39 0%, #FA617B 100%)',
        gradient2: 'linear-gradient(135deg, #FABA52 0%, #FFB8B8 100%)',
        gradient3: 'linear-gradient(135deg, #FFD4A3 0%, #FFE8E8 100%)',
        gradient4: 'linear-gradient(135deg, #FFE8E8 0%, #FFFFFF 100%)',
    },
});

export default Theme;
